import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./features/Header";
import Footer from "./features/Footer";
import { Box, styled } from "@mui/material";
import Loading from "./components/Loading";
import Cart from "./features/Cart";
import { Toaster } from "react-hot-toast";
import AccessorySelection from "./features/AccessorySelection";

const ProductCategoryGrid = lazy(
  () => import("./features/ProductCategoryGrid")
);
const ProductConfiguration = lazy(
  () => import("./features/ProductConfiguration")
);

const CategoryGrid = lazy(() => import("./components/Category/CategoryGrid"));
const ProductGrid = lazy(() => import("./components/Product/ProductGrid"));
const ContactUs = lazy(() => import("./features/ContactUs"));

const Content = styled(Box)(() => ({
  margin: "72px auto 65px",
}));

function App() {
  return (
    <Box component="main">
      <Header />
      <Content>
        <Suspense
          fallback={
            <Box sx={{ height: "100vh" }}>
              <Loading />
            </Box>
          }
        >
          <Routes>
            <Route element={<ProductCategoryGrid />}>
              <Route index element={<CategoryGrid />} />
              <Route path="products/:categoryId" element={<ProductGrid />} />
            </Route>

            <Route path="configure">
              <Route
                path=":productId/:categoryId"
                element={<ProductConfiguration />}
              />
            </Route>

            <Route path="select">
              <Route path=":productId" element={<AccessorySelection />} />
            </Route>

            <Route path="cart" element={<Cart />} />
            <Route path="contact-us" element={<ContactUs />} />
          </Routes>
        </Suspense>
        <Toaster />
      </Content>

      <Footer />
    </Box>
  );
}

export default App;
